// Module
var code = "<service-contracts-grid on-select=\"onContractSelected($event)\" on-summary=\"onContractSummary($event)\"></service-contracts-grid>\n";
// Exports
module.exports = code;